export default __webpack_public_path__ + "static/favicon-180-touch-3b76cc3d1997513173674349bdb40f22.png";